import { render, staticRenderFns } from "./IdeaOuterProductCarton.vue?vue&type=template&id=1f75993c&"
import script from "./IdeaOuterProductCarton.vue?vue&type=script&lang=js&"
export * from "./IdeaOuterProductCarton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports